<template>
  <div class="score container">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="title_input">
        <el-input v-model="form.name" placeholder="请输入标题"></el-input>
      </div>
    </div>
    <div class="main">
      <el-form ref="form" :model="form" label-width="140px">
        <el-form-item label="去掉最低分和最高分">
          <el-switch v-model="form.removeMaxMin"></el-switch>
        </el-form-item>
        <el-form-item label="允许参与者查看统计">
          <el-switch v-model="form.lookStatistics"></el-switch>
        </el-form-item>
        <el-form-item label="匿名投票">
          <el-switch v-model="form.anonymous"></el-switch>
        </el-form-item>
        <el-form-item label="自动结束">
          <el-switch v-model="form.autoStop"></el-switch>
        </el-form-item>
        <el-form-item label="活动时长" v-show="form.autoStop">
          <el-input-number
            size="mini"
            v-model="day"
            :controls="false"
            :min="0"
            :max="29"
          ></el-input-number
          ><span style="margin: 0 20px">天</span>
          <el-input-number
            size="mini"
            v-model="hour"
            :controls="false"
            :min="0"
            :max="23"
          ></el-input-number
          ><span style="margin: 0 20px">小时</span>
          <el-input-number
            size="mini"
            v-model="minute"
            :controls="false"
            :min="0"
            :max="59"
          ></el-input-number
          ><span style="margin: 0 20px">分钟</span>
        </el-form-item>
        <el-form-item label="分项评分">
          <el-switch v-model="form.separate"></el-switch>
          <span v-show="form.separate" style="margin-left: 80px; color: #999"
            >当前总分
            <span style="color: #ff0000">{{ totalscore }}</span> 分</span
          >
        </el-form-item>
        <div class="score-item" v-show="form.separate">
          <div class="one-item" v-for="(item, idx) in scoreItem" :key="idx">
            <el-input
              v-model="item.name"
              size="mini"
              placeholder="请输入评分内容"
            ></el-input>
            <div class="item-score">
              占<el-input-number
                v-model="item.score"
                :min="0"
                :controls="false"
                size="mini"
              ></el-input-number
              >分
            </div>
            <i class="el-icon-close" @click="handleDel(idx)"></i>
          </div>
          <el-button type="text" @click="handleAddItem">添加评分项</el-button>
        </div>
        <el-form-item class="btn_row">
          <el-button
            type="primary"
            @click="handleSave(true)"
            style="margin-right: 50px"
            >立即开始</el-button
          >
          <el-button @click="handleSave(false)">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import mixinsData from "../mixins";
import { formatNumber } from "@/utils";

export default {
  name: "score",
  mixins: [mixinsData],
  data() {
    return {
      formatNumber,
      form: {
        type: "SCORE",
        classChapterId: null,
        classId: null,
        name: "",
        removeMaxMin: false,
        lookStatistics: false,
        anonymous: false,
        autoStop: true,
        separate: false,
        status: "PEND",
        scoreItem: "",
      },
      day: 0,
      hour: 0,
      minute: 30,
      scoreItem: [
        { name: "", score: 0 },
        { name: "", score: 0 },
      ],
    };
  },
  deactivated() {
    this.form = this.$options.data().form;
    this.day = this.$options.data().day;
    this.hour = this.$options.data().hour;
    this.minute = this.$options.data().minute;
  },

  computed: {
    duration() {
      return this.day * 24 * 60 + this.hour * 60 + this.minute;
    },
    totalscore() {
      return Number(
        this.scoreItem.reduce((prev, curr) => {
          return curr.score + prev;
        }, 0)
      );
    },
  },
  methods: {
    handleAddItem() {
      this.scoreItem.push({ scoreItem: "", score: 0 });
    },
    handleDel(idx) {
      if (this.scoreItem.length <= 1) {
        this.$message.warning("至少保留一项评分内容");
        return;
      }
      this.scoreItem.splice(idx, 1);
    },
    handleSave(start) {
      this.form.classChapterId = this.$route.query.classChapterId;
      this.form.classId = this.$route.query.id;

      if (start) this.form.status = "STARTED";
      else this.form.status = "PEND";
      this.form.duration = this.duration;
      if (this.$route.query.activityId) {
        // 修改
        this.form.activityId = this.$route.query.activityId;
        this.handleEdit(this.form);
      } else {
        // 新增
        this.handleAdd(this.form);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.score {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 44px;
      }
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .title_input {
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
    }
  }
  .main {
    padding: 60px 280px;
    height: calc(100% - 30px - 20px - 88px - 30px);
    background-color: #fff;
    text-align: left;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .el-input-number {
      width: 60px;
    }
    .score-item {
      margin-bottom: 20px;
      background: #f9f9f9;
      padding: 22px;
      .one-item {
        margin-bottom: 10px;
        &:hover {
          .el-icon-close {
            opacity: 1;
          }
        }
        .el-input {
          width: 70%;
        }
        .item-score {
          display: inline-block;
          margin-left: 30px;
          ::v-deep .el-input__inner {
            border-top: none;
            border-left: none;
            border-right: none;
            background-color: inherit;
          }
        }
        .el-icon-close {
          display: inline-block;
          margin-left: 30px;
          color: #999;
          font-size: 20px;
          vertical-align: middle;
          cursor: pointer;
          transition: opacity 0.3s ease;
          opacity: 0;
        }
      }
    }
    ::v-deep .btn_row {
      text-align: center;
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
}
</style>